/**
 * HOME-ACTIONS-PLAN.WIDGET
 * Access to the action plan from the home page
 */
import Card from "@/components/card"
import { useEffect, useState } from "react"
import { store } from "@/core/root-reducer"
import { actionPlanActivate, actionPlanFetchSelf } from "@/redux/action-plan.actions"
import { ActionPlan } from "@/redux/action-plan.types"
import PageLoader from "@/components/page-loader"
import { STATUS_LOADED, STATUS_LOADING } from "@/redux/_status.types"
import GetSurveyResultsModal from "@/modals/get-survey-results.modal"
import { surveyActivate } from "@/redux/survey.actions"

function HomeActionsPlanWidget() {
  const [actionPlan, setActionPlan] = useState<ActionPlan | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [modal, setModal] = useState<null | "GET_SURVEY_RESULTS">(null)

  useEffect(() => {
    load()
    async function load() {
      const actionPlans: any = await store.dispatch(actionPlanFetchSelf())
      setIsLoading(false)
      if (!actionPlans.error) {
        const currentActionPlan = actionPlans.filter((x: ActionPlan) => x.status === "draft" || x.status === "active")
        if (currentActionPlan.length) {
          store.dispatch(actionPlanActivate(currentActionPlan[0]))
          setActionPlan(currentActionPlan[0])
        }
      }
    }
  }, [])

  return (
    <PageLoader status={isLoading ? STATUS_LOADING : STATUS_LOADED}>
      {modal === "GET_SURVEY_RESULTS" && (
        <GetSurveyResultsModal
          onClose={() => setModal(null)}
          destination={
            actionPlan?.status === "draft" && actionPlan?.tasks.length === 0 ? "/tasks/wizard" : "/tasks/edit"
          }
        />
      )}

      {actionPlan && (
        <Card
          className={"flex1 orange white-t flex _hover"}
          onClick={() => {
            store.dispatch(surveyActivate(actionPlan.Survey))
            setModal("GET_SURVEY_RESULTS")
          }}>
          {actionPlan.status === "draft" ? (
            <b>{`Vous êtes invité⸱e à rédiger un plan d'action.`}</b>
          ) : (
            <b>{`Vous avez un plan d'action en cours.`}</b>
          )}
        </Card>
      )}
    </PageLoader>
  )
}

export default HomeActionsPlanWidget
